import { NavigationPage } from '@/app/components'
import { ReviewingPermissions } from '@/app/components/SurveyObserver/TeslaFleetAuthSurvey'
import { batteryPermissions } from './constants'
import { useEnergySystemFleetAuthUrl } from './hooks'
import { trackConnectionStarted } from '@/logging/segment'

const MockVehicleResource = {
  id: 1,
  car: {
    display_name: 'Your Powerwall',
    car_model: {
      make: 'Tesla',
      model: 'Review Permissions',
      friendly_model: null,
    },
  },
}

function useViewModel() {
  const url = useEnergySystemFleetAuthUrl()
  const onContinueClick = () => {
    trackConnectionStarted('utility', 'tesla')
    window.location.href = url
  }
  return { onContinueClick }
}

export default function TeslaEnergySystemPermissionsStatementPage() {
  const { onContinueClick } = useViewModel()

  return (
    <NavigationPage id="powerwall-permissions-notification">
      <NavigationPage.SingleCardContent>
        <ReviewingPermissions
          vehicles={[MockVehicleResource]}
          onContinueClick={onContinueClick}
          permissions={batteryPermissions}
        />
      </NavigationPage.SingleCardContent>
    </NavigationPage>
  )
}
